/**
 * Datepicker Pikaday
 * es6 - NO JQUERY
 */

class Datepicker {
    /**
     * Set Atributes:
     * - data-init-value                                 -- set default value of date:
     *                   = first-of-month                -- on first day of next month.
     *                   = datepicker-first-of-month     -- on first day of next month of the datepicker.
     *                   = first-of-year                 -- on january 1st of next year.
     *                   = birthdate                     -- on january 1st of 1970.
     *                   = birthdate-child               -- on january 1st of 2000.
     * - data-min-date                                   -- minimal date (start of calendar).
     */

    constructor(element, options) {
        this.date = new Date();
        this.dateYear = this.date.getFullYear();
        this.dateMonth = this.date.getMonth() + 1;
        this.datepicker = '';
        this.datepickerField = element;
        this.datepickerFieldAlt = '';
        this.datepickerOptions = options;
        this.datepickerTrigger = '';
        this.datepickerFieldType = 'date';
        this.datepickerFormat = 'DD-MM-YYYY';
        this.datepickerFormatNL = 'dd-mm-jjjj';
        this.datepickerLanguage = {
            previousMonth: 'Vorige maand',
            nextMonth: 'Volgende maand',
            months: [
                'Januari',
                'Februari',
                'Maart',
                'April',
                'Mei',
                'Juni',
                'Juli',
                'Augustus',
                'September',
                'Oktober',
                'November',
                'December'
            ],
            weekdays: [
                'Zondag',
                'Maandag',
                'Dinsdag',
                'Woensdag',
                'Donderdag',
                'Vrijdag',
                'Zaterdag'
            ],
            weekdaysShort: ['Zo', 'Ma', 'Di', 'Wo', 'Do', 'Vr', 'Zat']
        };
        this.datepickerSettings = {
            field: this.datepickerField,
            trigger: this.datepickerTrigger,
            format: this.datepickerFormat,
            i18n: this.datepickerLanguage,
            firstDay: 1,
            yearRange: [1900, this.dateYear],
            blurFieldOnSelect: true,
            onSelect: () => {
                this.datepickerField.focus();
            },
            onClose: () => {
                this.datepickerField.blur();
            }
        };

        // Set type datepicker based on birthdate
        this.datepickerFieldType = this.datepickerOptions.initValue === 'birthdate' || this.datepickerOptions.initValue === 'birthdate-child' ? 'text' : 'date';

        // Add datepicker__field class for new styling.
        this.datepickerField.classList.add('datepicker__field');

        // check based on screen size if picker needs to be created or destroyed.
        this.createDatepicker();
    }

    createDatepicker() {
        // Adjust datepicker settings based on given data-attributes options before creating it.
        this.adjustSettings();

        // create datepicker with datepicker settings.
        this.datepicker = new Pikaday(this.datepickerSettings);

        // Set data-attribute 'type' to 'text'.
        this.datepickerField.setAttribute('type', 'text');
    }

    adjustSettings() {
        // set default year of the datepicker.
        let defaultDate = '',
            setDefaultDate = false,
            defaultBirthdate = '01-01-1970',
            defaultBirthdateChild = '01-01-2000',
            defaultFirstofMonth = new Date(this.dateYear, this.dateMonth, 1);

        // check initValue.
        if(this.datepickerOptions.initValue) {
            // Set default date
            if(this.datepickerOptions.initValue === 'birthdate') {
                defaultDate = defaultBirthdate;
            } else if(this.datepickerOptions.initValue === 'birthdate-child') {
                defaultDate = defaultBirthdateChild;
            } else if(this.datepickerOptions.initValue === 'datepicker-first-of-month') {
                defaultDate = defaultFirstofMonth;
            } else if(this.datepickerOptions.initValue === 'first-of-month') {
                defaultDate = new Date(this.dateYear, this.dateMonth, 1);
                setDefaultDate = true;
            } else if(this.datepickerOptions.initValue === 'first-of-year') {
                defaultDate = new Date(this.dateYear + 1, 0, 1);
                setDefaultDate = true;
            }
        }

        // if value has been filled, use that as defaultDate
        if(this.datepickerField.value.trim() !== '') {
            defaultDate = this.datepickerField.value;
            setDefaultDate = true;
        }

        // create datepicker trigger.
        this.datepickerField.insertAdjacentHTML('afterend', '<span class="datepicker__trigger no-copy"></span>');
        this.datepickerTrigger = this.datepickerField.nextElementSibling;

        // Add to datepicker settings.
        this.datepickerSettings.trigger = this.datepickerTrigger;
        this.datepickerSettings.defaultDate = moment(defaultDate, this.datepickerFormat).toDate();
        this.datepickerSettings.setDefaultDate = setDefaultDate;
    }
}
